export * from './error-500.component';
export * from './error-500.module';
